import { deleteFileDocuments, uploadFiles } from '../Services/firebaseService';

/**
 * Realiza o upload de novos arquivos para o Firebase.
 */
export const processFileUploads = async (files, origin, originId, prefix = 'file') => {
  const uploadPromises = files.map(async (file, index) => {
    // Garante que o arquivo real (File object) seja usado
    const actualFile = file.originFileObj || file;
    const fileName = file.label || file.name || actualFile.name || `file_${index}`;

    if (!actualFile) {
      throw new Error(`Arquivo real não encontrado para: ${fileName}`);
    }

    const fileExtension = fileName.split('.').pop() || 'tmp';
    const newFileName = `${originId}_${prefix}_${Date.now()}_${index}.${fileExtension}`;

    const fileURL = await uploadFiles(actualFile, origin, originId, newFileName);

    return {
      label: fileName, // Usa o nome original do arquivo como label
      name: newFileName,
      url: fileURL,
    };
  });

  return Promise.all(uploadPromises);
};

/**
 * Exclui arquivos do Firebase Storage.
 */
export const deleteRemovedFiles = async (removedFiles) => {
  if (!removedFiles || removedFiles.length === 0) return;

  const deletePromises = removedFiles.map((file) =>
    deleteFileDocuments(file.name, 'trainings', file.originId || file.taskId)
  );
  await Promise.all(deletePromises);
};

/**
 * Constrói a lista final de arquivos, combinando os originais com os novos.
 */
export const buildFinalFileList = (originalFiles, removedFiles, uploadedFiles) => {
  const remainingOriginalFiles = originalFiles.filter(
    (originalFile) => !removedFiles.some((removedFile) => originalFile.url === removedFile.url)
  );

  return [...remainingOriginalFiles, ...uploadedFiles];
};
